import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

export const Contact = () => {
  return (
    <div data-testid="contact-page" className="min-h-screen pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4 font-medium">Get in Touch</p>
          <h1 className="font-display text-5xl md:text-6xl font-normal tracking-tight text-foreground mb-6">
            Contact <span className="italic">Us</span>
          </h1>
          <p className="text-lg font-light leading-relaxed text-muted-foreground max-w-2xl mx-auto">
            We'd love to hear from you. Reach out to us for any inquiries about our products or services.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="border border-white/10 p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <MapPin className="text-primary mt-1 flex-shrink-0" size={24} strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-xl mb-2">Address</h3>
                  <p className="text-muted-foreground font-light">
                    1568, Mahatma Gandhi Road<br />
                    Near LIC Building, Ashok Nagar<br />
                    Kannauj, Uttar Pradesh 209725<br />
                    India
                  </p>
                </div>
              </div>
            </div>

            <div className="border border-white/10 p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <Phone className="text-primary mt-1 flex-shrink-0" size={24} strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-xl mb-2">Phone</h3>
                  <a 
                    href="tel:+919108279182" 
                    className="text-muted-foreground hover:text-primary transition-colors duration-300 font-light"
                  >
                    +91 91082 79182
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-white/10 p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <Mail className="text-primary mt-1 flex-shrink-0" size={24} strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-xl mb-2">Email</h3>
                  <a 
                    href="mailto:krishnasugandh@outlook.com" 
                    className="text-muted-foreground hover:text-primary transition-colors duration-300 font-light"
                  >
                    krishnasugandh@outlook.com
                  </a>
                </div>
              </div>
            </div>

            <div className="border border-white/10 p-8 space-y-6">
              <div className="flex items-start space-x-4">
                <Clock className="text-primary mt-1 flex-shrink-0" size={24} strokeWidth={1.5} />
                <div>
                  <h3 className="font-display text-xl mb-2">Business Hours</h3>
                  <p className="text-muted-foreground font-light">
                    Monday - Saturday: 9:00 AM - 7:00 PM<br />
                    Sunday: Closed
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="h-[600px] border border-white/5"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.7842157!2d79.91486!3d27.05831!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399e651ba8601785%3A0x5d84588dfbda3f18!2sKRISHNA%20SUGANDH!5e0!3m2!1sen!2sin!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Krishna Sugandh Location"
            />
          </motion.div>
        </div>
      </div>
    </div>
  );
};